import { render, staticRenderFns } from "./bo-snackbar.vue?vue&type=template&id=11765d90"
import script from "./bo-snackbar.vue?vue&type=script&lang=js"
export * from "./bo-snackbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports